<template>
  <div class="dialog-mask" @click.self="onClickClose">
    <div class="dialog-box">
      <!-- 閉じるボタン -->
      <div class="close-button" @click="onClickClose">
        <div class="icon">
          <Close />
        </div>
        <div class="label">
          {{ $t("common.close") }}
        </div>
      </div>

      <!-- タイトル -->
      <div class="dialog-title">
        {{ $t("eventCompanyDialog.title") }}
      </div>

      <!-- 猫＋本画像 -->
      <div class="main-image">
        <img src="@/assets/img/event/company/lying_cat.png" class="image" alt="main_image" />
      </div>

      <!-- 編集部の掲示板の説明 -->
      <div>
        <div class="description-title">
          {{ $t("eventCompanyDialog.mainFeatures") }}
        </div>

        <div class="description-container">
          <div class="description-box">
            <img src="@/assets/img/event/company/reader.png" class="icon" alt="reader_icon" />
            <div>
              <div class="title">
                {{ $t("eventCompanyDialog.feature1.title") }}
              </div>
              <div class="text">
                {{ $t("eventCompanyDialog.feature1.text") }}
              </div>
            </div>
          </div>

          <div class="description-box">
            <img src="@/assets/img/event/company/board.png" class="icon" alt="board_icon" />
            <div>
              <div class="title">
                {{ $t("eventCompanyDialog.feature2.title") }}
              </div>
              <div class="text">
                {{ $t("eventCompanyDialog.feature2.text") }}
              </div>
            </div>
          </div>

          <div class="description-box">
            <img src="@/assets/img/event/company/reaction.png" class="icon" alt="reaction_icon" />
            <div>
              <div class="title">
                {{ $t("eventCompanyDialog.feature3.title") }}
              </div>
              <div class="text">
                {{ $t("eventCompanyDialog.feature3.text") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Close from "icons/Close.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Close,
  },
  props: {
  },
  methods: {
    onClickClose() {
      this.$close(true);
    },
  },
});

interface Data {}

interface Methods {
  onClickClose: () => void;
}

interface Props {}

interface Computed {}
</script>
  
<style lang="scss" scoped>
.dialog-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: -ms-flexbox;
  display: flex;
  z-index: 9000;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

.dialog-box {
  width: 416px;
  border-radius: var(--radius-md);
  background-color: var(--color-background-normal);
  position: relative;
  color: var(--color-text-normal);
}

.close-button {
  position: absolute;
  right: 33px;
  top: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  .icon {
    transform: scale(2);
    transform-origin: center;
  }
  .label {
    color: var(--color-text-normal);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-bold);
    line-height: 12px;
  }
}

.dialog-title {
  text-align: center;
  margin-top: 24px;
  color: var(--color-text-normal);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  line-height: 24px;
}

.main-image {
  margin: 24px 120px 0;

  .image {
    height: 76px;
  }
}

.description-title {
  text-align: center;
  color: var(--color-text-normal);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: 24px;
  margin-top: 24px;
}

/* 最初の子要素 */
.description-container > :first-child {
  margin-top: 16px; 
}

/* 2つ目以降の子要素 */
.description-container > :not(:first-child) {
  margin-top: 8px; 
}

/* 最後の子要素 */
.description-container > :last-child {
  margin-bottom: 29px; 
}

.description-box {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
  padding: 16px;
  border-radius: var(--radius-xs);
  border: 1px solid var(--color-border);
  background-color: var(--color-surface-subtle);
  column-gap: 8px;

  .icon {
    width: 48px;
    height: 48px;
  }

  .title {
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-normal);
  }

  .text {
    margin-top: 8px;
    font-size: var(--font-size-xs);
    font-weight: 350;
    color: var(--color-text-low);
  }
}
</style>
  